import { render, staticRenderFns } from "./ViewMyAcademy.vue?vue&type=template&id=cb1f5b9e&scoped=true"
import script from "./ViewMyAcademy.vue?vue&type=script&lang=js"
export * from "./ViewMyAcademy.vue?vue&type=script&lang=js"
import style0 from "./ViewMyAcademy.vue?vue&type=style&index=0&id=cb1f5b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1f5b9e",
  null
  
)

export default component.exports